import React from "react";
import HomeLayout from "../layouts/home";
import { useTranslation } from "../contexts/I18nProvider";

const Terms = () => {
  const { t } = useTranslation();

  return (
    <HomeLayout>
      <div className="max-w-4xl mx-auto p-6 text-gray-800">
        <h1 className="text-3xl font-bold mb-4">{t('pages.terms.title')}</h1>
        <p className="mb-4">
          {t('pages.terms.intro')}
        </p>

        {/* Section 1: Use of Service */}
        <section className="mb-6">
          <h2 className="text-xl font-semibold mb-2">{t('pages.terms.useOfService')}</h2>
          <p>
            {t('pages.terms.useOfServiceDesc')}
          </p>
        </section>

        {/* Section 2: Accounts and Payments */}
        <section className="mb-6">
          <h2 className="text-xl font-semibold mb-2">
            {t('pages.terms.accountsPayments')}
          </h2>
          <p>
            {t('pages.terms.accountsPaymentsDesc')}
          </p>
          <ul className="list-disc list-inside mt-2">
            <li>{t('pages.terms.noRefunds')}</li>
            <li>
              {t('pages.terms.autoRenewal')}
            </li>
            <li>{t('pages.terms.pricingChanges')}</li>
          </ul>
        </section>

        {/* Section 3: Privacy */}
        <section className="mb-6">
          <h2 className="text-xl font-semibold mb-2">{t('pages.terms.privacy')}</h2>
          <p>
            {t('pages.terms.privacyDesc')} {" "}
            <a href="/privacy" className="text-blue-500 underline">
              {t('footer.privacy')}
            </a>
            .
          </p>
        </section>

        {/* Section 4: Disclaimer */}
        <section className="mb-6">
          <h2 className="text-xl font-semibold mb-2">{t('pages.terms.disclaimer')}</h2>
          <p>
            {t('pages.terms.disclaimerDesc')}
          </p>
        </section>

        {/* Section 5: Changes to Terms */}
        <section className="mb-6">
          <h2 className="text-xl font-semibold mb-2">{t('pages.terms.changesTerms')}</h2>
          <p>
            {t('pages.terms.changesTermsDesc')}
          </p>
        </section>

        <footer className="text-sm text-gray-800 mt-8">
          <p>
            {t('pages.terms.footerIntro')}{" "}
            <a
              href={`mailto:${process.env.REACT_APP_TERMS_EMAIL}`}
              className="text-blue-500 underline"
            >
              {process.env.REACT_APP_TERMS_EMAIL}
            </a>
            .
          </p>
          <p className="mt-2">
            {t('pages.terms.effectiveDate')}: {new Date().toLocaleDateString()}
          </p>
        </footer>
      </div>
    </HomeLayout>
  );
};

export default Terms;
